import { EnablePublishLayerService } from 'app/services/enable-publish-layer.service';
import { ToastrService } from 'ngx-toastr';
import * as i0 from "@angular/core";
import * as i1 from "../services/enable-publish-layer.service";
import * as i2 from "ngx-toastr";
var PublishLayerGuard = /** @class */ (function () {
    function PublishLayerGuard(enableService, toastr) {
        this.enableService = enableService;
        this.toastr = toastr;
    }
    PublishLayerGuard.prototype.canActivate = function (next, state) {
        var value = this.enableService.getValue();
        if (value == false) {
            this.toastr.warning('No published layer created!');
        }
        return value;
    };
    PublishLayerGuard.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function PublishLayerGuard_Factory() { return new PublishLayerGuard(i0.ɵɵinject(i1.EnablePublishLayerService), i0.ɵɵinject(i2.ToastrService)); }, token: PublishLayerGuard, providedIn: "root" });
    return PublishLayerGuard;
}());
export { PublishLayerGuard };
